import { h, resolveComponent } from 'vue';

export default {
  props: {
    componentName: {
      type: String,
      required: true
    },
    componentProps: {
      type: Object,
      default: () => ({})
    }
  },
  setup(props) {
    return () => {
      const ResolvedComponent = resolveComponent(props.componentName);
      if (typeof ResolvedComponent === 'string') {
        console.error(`[ComponentResolver] Component "${props.componentName}" not found.`);
        return null;
      }

      return h(ResolvedComponent, props.componentProps);
    };
  }
};
